import{a as e}from"./chunk-TIVE5C2A.js";import{a as c}from"./chunk-RVLU2OIQ.js";import{e as t}from"./chunk-AHDTGOQY.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-LSR5VN5P.js.map
